import { IBackendProgram, IGetProgram, IProgramMap } from "../interfaces";
import { get, post } from "../util/api";
import { formatProgram } from "../util/format-program";

export async function fetchAllPrograms(
  token: string,
  campaignId?: string
): Promise<IProgramMap> {
  let url = `${process.env.HOST_ENV}/reward/v1.1/user/program`;
  if (campaignId) {
    url = url + "?campaignId=" + campaignId;
  }
  try {
    let programs: IBackendProgram[] = [];
    if (process.env.MODE === "DEMO") {
      const urlParams = new URLSearchParams(window.location.href);
      const configParam = urlParams.get("config");
      if(configParam){
        programs = [];
      }else{
        programs = await (await import("./mock/program")).default();
      }
     
    } else {
      const res = await get<IGetProgram>(url, token);
      const body = res.parsedBody;
      if (!body || !body.success || !body.programs)
        throw `Invalid Response, ${
          body && body["message"] ? "cause: " + body["message"] : null
        }`;
      programs = body.programs;
    }

    const now = new Date();
    const cleanedPrograms = [];

    programs.forEach((p) => {
      try {
        const formattedProgram = formatProgram(p);
        cleanedPrograms.push(formattedProgram);
      } catch (e) {
        console.log(e);
      }
    });

    const programsMap: IProgramMap = {
      allIds: [],
      byId: {},
    };
    cleanedPrograms.forEach((p) => {
      programsMap.allIds.push(p.campaignId);
      programsMap.byId[p.campaignId] = p;
    });
    return programsMap;
  } catch (e) {
    throw e;
  }
}

export async function checkInStreak(campaignId: string, token: string) {
  try {
    const res = await post(
      `${process.env.HOST_ENV}/state/v1.1/processEvents`,
      {
        event: "CHECK_IN",
        properties: {
          gluState: 1,
        },
      },
      token
    );
    const body = res.parsedBody;
    if (!body || !body["success"]) throw "checkin failed";
    const programs = await fetchAllPrograms(token, campaignId);
    return programs;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function acceptChallenge(campaignId: string, token: string) {
  try {
    const url = `${process.env.HOST_ENV}/reward/v1.1/user/program/accept`;
    const res = await post<any>(url, { campaignId, choice: "accept" }, token);

    const body = res.parsedBody;
    if (!body || !body["success"]) throw "accept failed";
    const programs = await fetchAllPrograms(token, campaignId);
    return programs;
  } catch (e) {
    console.log(e);
    throw e;
  }
}
